import type { Transaction } from '@shared/transactions-types';
import { isFeatureEnabled } from '@luna/gatekeeper';

import { parseOptionalDate } from './parseOptionalDate';

export const getTransactionDate = ({
    bookingDate,
    transactionDateTime,
}: Transaction): Date | undefined => {
    const displayExecutionDate = isFeatureEnabled((f) => f.transactions.displayExecutionDate);
    const displayedDate = displayExecutionDate ? transactionDateTime : bookingDate;
    return parseOptionalDate(displayedDate);
};
